export default "__VITE_ASSET__Dkz$sGrO__"